// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 593 ? "component---gatsby-theme-landing-page-src-pages-contentful-landing-page-slug-js" : chunkId) + "-" + {"593":"dfd3e665aeb406618538","731":"464e6652ef4c5cbb20b4","843":"afcb02974ea537075ab6"}[chunkId] + ".js";
};